import { render } from "./WhatsAppButton.vue?vue&type=template&id=57ae94ed&scoped=true"
import script from "./WhatsAppButton.vue?vue&type=script&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&lang=js"

import "./WhatsAppButton.vue?vue&type=style&index=0&id=57ae94ed&scoped=true&lang=css"

import exportComponent from "/Users/peter/projects/BhubCollege/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ae94ed"]])

export default __exports__